import { render, staticRenderFns } from "./lisShow.vue?vue&type=template&id=5ca53c30&scoped=true"
import script from "./lisShow.vue?vue&type=script&lang=js"
export * from "./lisShow.vue?vue&type=script&lang=js"
import style0 from "./lisShow.vue?vue&type=style&index=0&id=5ca53c30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca53c30",
  null
  
)

export default component.exports